import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {ReportPageVO, useQueryReportPage} from "@/service/report.s";
import {useAuthInfo} from "@/store/account.c";
import {WriteReport} from "@/pages/Report/WriteReport";
import {ProgressBar} from "@/widget/ProgressBar/ProgressBar";
import Chip from "@mui/material/Chip";
import {assign} from "lodash";
import {AuthButtonVO} from "@/service/menu.s";
import {TaskReview} from "@/widget/TaskReview/TaskReview";
import {ViewReport} from "@/pages/Report/ViewReport";

export const ReportListPage = () => {
    const {
        mutate: reportPageMutate,
        data: reportPageData,
        isPending: reportPagePending,
    } = useQueryReportPage()
    const {id: authId} = useAuthInfo()

    const columns: GridColDef<ReportPageVO>[] = [
        {field: "taskName", headerName: "任务名称", flex: 0.9},

        {
            field: "virtue",
            headerName: "任务属性",
            headerAlign: "center",
            align: "center",
            renderCell: ({row: {virtue, virtueId}}) => {
                let style = {}
                if (virtueId == 1) {
                    style = {"& .MuiChip-label": {color: '#fff'}, backgroundColor: '#eb5050 !important', border: 'none'};
                } else if (virtueId == 2) {
                    style = {"& .MuiChip-label": {color: '#fff'}, backgroundColor: '#f0a800 !important', border: 'none'};
                }
                return <Chip label={virtue} variant={'filled'} size={'small'} sx={style}/>
            }
        },
        {
            field: "createdAt",
            headerName: "汇报日期",
            headerAlign: "right",
            align: "right",
            valueFormatter: (value) => formatTime("D", value),
        },
        {
            field: "ratio", headerName:
                "任务进度", flex:
                0.8, headerAlign:
                'center', valueGetter:
                (value, row) => row.ratio, type:
                'number', renderCell:
            ProgressBar
        },
        {
            field: "creator",
            headerName: "汇报人",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
        },
        {
            field: "priority",
            headerName: "优先级",
            headerAlign: "center",
            align: "center",
            renderCell: ({row: {priority, priorityId}}) => {
                let style = {}
                if (priorityId == 1) {
                    style = {backgroundColor: '#fa5353 !important', border: 'none'};
                } else if (priorityId == 2) {
                    style = {backgroundColor: '#ff9d8d !important', border: 'none'};
                } else if (priorityId == 3) {
                    style = {backgroundColor: '#f5c13c !important', border: 'none'};
                } else if (priorityId == 4) {
                    style = {backgroundColor: '#3f8cff !important', border: 'none'};
                } else if (priorityId == 5) {
                    style = {backgroundColor: '#2fcd6e !important', border: 'none'};
                }
                return <Chip label={priority} variant={'filled'} size={'small'} sx={assign(style, {"& .MuiChip-label": {color: '#fff'}})}/>
            }
        },
        {
            field: "planName",
            headerName: "目标计划",
            headerAlign: "center",
            align: "center",
            flex: 0.6
        },
        {
            field: "executor",
            headerName: "负责人",
            headerAlign: "center",
            align: "center",
            flex: 0.6
        },
        {
            field: "nodeNames",
            headerName: "审核状态",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            renderCell: ({row: {status}}) => {
                let style = {}
                let text = "待审核"
                if (status == -1) {
                    style = {"& .MuiChip-label": {color: '#fff'}, backgroundColor: '#eb5050 !important', border: 'none'};
                    text = "未通过"
                } else if (status == 1) {
                    style = {"& .MuiChip-label": {color: '#fff'}, backgroundColor: '#f0a800 !important', border: 'none'};
                    text = "已通过"
                }
                return <Chip label={text} variant={'filled'} size={'small'} sx={style}/>
            }
        },
    ];

    return (
        <ProTable<ReportPageVO>
            loading={reportPagePending}
            verifyBtns={(row: ReportPageVO, btns: AuthButtonVO[]) => {
                return btns.map((btn) => {
                    if (btn.alias == 'audit') {
                        return {...btn, disabled: row.executorId !== authId || row.status != 0, maxWidth: 'xs', body: <TaskReview tag={1}/>}
                    }
                    return btn
                })
            }}
            renderDrawer={{view: <ViewReport/>, write: <WriteReport/>}}
            columns={columns}
            data={reportPageData?.data}
            onSearch={(params) => {
                reportPageMutate(params);
            }}
            code={"report"}
        />
    );
};
